/**
 * SCIP Server API
 * SCIP Server
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoadingInfo } from './loading-info';


export interface ReportRequestDto { 
    searchInfo: LoadingInfo;
    /**
     * Report type, required if there\'s no information about Search
     */
    reportType?: ReportRequestDtoReportTypeEnum;
}
export enum ReportRequestDtoReportTypeEnum {
    ProductsDownload = 'PRODUCTS_DOWNLOAD',
    DossiersDownload = 'DOSSIERS_DOWNLOAD'
};



